<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <!-- 头部 -->
    <div class="page-heading">
      <div class="container">
        <div class="heading-content">
          <h1>成功案例</h1>
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <div class="tabs tabs-style-linebox hidden-xs">
      <div class="zznav">
        <ul class="zzitem">
          <li><a @click="forId('dxal')">行业案例</a></li>
          <li><a @click="forId('alfx')">典型分析</a></li>
        </ul>
      </div>
    </div>
    <!-- 小滚轮 -->
    <div id="ss_menu">
        <div>
          <i
            ><a @click="forId('alfx')">典型<br />分析</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('dxal')">行业<br />案例</a></i
          >
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    <!-- 典型案例 -->
    <div class="cgcon" id="dxal" >
      <div class="htmleaf-container">
        <!-- COIDEA:demo START -->
        <section class="coidea-grid-holder">
          <!-- COIDEA:demo:grid:headline START -->
          <div class="coidea-headline" >
            <h1>行业案例</h1>
            <p></p>
          </div>
        </section>
      </div>
    </div>
    <div>
      <div class="col-md-2 dxalift col-xs-12">
        <!-- 案例搜索 -->
        <div class="row ssal">
          <div class="altop">
            <strong class="alTitle">案例搜索</strong>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;Search</span>
          </div>
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 control-label col-xs-2 foSize"
                >分类：</label
              >
              <div class="col-sm-10 col-xs-10">
                <select
                  class="form-control"
                  ref="selectItem"
                  @change="getSelectData"
                >
                  <option>全部</option>
                  <option>海外工程</option>
                  <option>烟草饲料</option>
                  <option>材料磁业</option>
                  <option>汽车航空</option>
                  <option>电厂船坞</option>
                  <option>公用建筑</option>
                  <option>造纸包装</option>
                  <option>生物医药</option>
                  <option>建材家居</option>
                  <option>化工橡胶</option>
                  <option>纺织服饰</option>
                  <option>铝业钢业</option>
                  <option>物流仓储</option>
                  <option>机械工业</option>
                  <option>电子电器</option>
                  <option>超市卖场</option>
                  <option>食品饮料</option>
                  <option>五金制造</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-2 control-label col-xs-2 foSize"
                >内容：</label
              >
              <div class="col-sm-10 col-xs-10">
                <input
                  type="text"
                  class="form-control"
                  placeholder="搜索内容"
                  v-model="svalue"
                />
              </div>
            </div>
          </form>
          <div class="col-md-12 col-xs-12">
            <div class="row">
              <div class="col-md-offset-1 col-md-4 col-xs-offset-1 col-xs-4">
                <button
                  type="button"
                  class="btn btn-danger"
                  style="text-align: center"
                  @click="getCgalSearchData"
                >
                  搜索
                </button>
              </div>
              <div class="col-md-offset-2 col-md-4 col-xs-offset-2 col-xs-4">
                <button
                  type="button"
                  class="btn btn-warning"
                  style="text-align: center"
                  @click="getCgalData"
                >
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- 搜索列表 -->
        <div class="row hidden-xs">
          <div class="altop lbtop">
            <strong class="alTitle">搜索列表</strong>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;List</span>
          </div>
          <div class="col-md-12 col-xs-12" style="padding-left: 0;">
            <div class="row">
              <div
                class="col-md-3 col-xs-3 lbTop"
                v-for="item in listNum"
                :key="item"
              >
                <button
                  type="button"
                  class="btn btn-default lbButton"
                  @click="showpage(item)"
                >
                  {{ item }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 案例列表 -->
    <div class="col-md-10 col-xs-12">
      <div class="row">
        <div
          class="col-md-3 col-xs-6" style="padding: 0"
          v-for="(item, index) in showdata"
          :key="index"
        >
          <img :src="item.cgalImage" alt="" class="lbImg" />
          <h4 class="lbhi">{{ item.cgalTitle }}</h4>
        </div>
      </div>
    </div>
    <div
      class="col-xs-12 visible-xs"
      style="text-align: center; margin-top: 10px"
    >
      <p>
        <span style="margin-right: 20px" @click="pPage(nowNum)">上一页</span
        ><span>{{ nowNum }}/{{ listNum }}</span
        ><span style="margin-left: 20px" @click="nPage(nowNum)">下一页</span>
      </p>
    </div>
    <!-- 案例分析 -->
    <div class="cgcon" style="border-top: 1px solid #000;">
      <div class="htmleaf-container">
        <!-- COIDEA:demo START -->
        <section class="coidea-grid-holder" style="border-top: 1px solid #000;" id="alfx">
          <!-- COIDEA:demo:grid:headline START -->
          <div class="coidea-headline"  >
            <h1>典型分析</h1>
            <p></p>
          </div>
          <!-- COIDEA:demo:grid:headline END -->

          <!-- COIDEA:demo:grid START -->
          <div class="coidea-grid" ref="grid">
            <!-- COIDEA:demo:grid:item START -->
            <figure class="coidea-item" @click="handleAnim(1)">
              <div class="coidea-item-inner">
                <img v-lazy="cgal1" alt="Lazy-loaded Image" class="oldimg" />
                <p class="oldp">上海惠群广场</p>
              </div>
            </figure>
            <!-- COIDEA:demo:grid:item END -->

            <!-- COIDEA:demo:grid:item START -->

            <figure class="coidea-item" @click="handleAnim(2)">
              <div class="coidea-item-inner">
                <img v-lazy="cgal2" alt="Lazy-loaded Image" class="oldimg" />
                <p class="oldp">厦门银鹭集团</p>
              </div>
            </figure>
            <!-- COIDEA:demo:grid:item END -->

            <!-- COIDEA:demo:grid:item START -->
            <figure class="coidea-item" @click="handleAnim(3)">
              <div class="coidea-item-inner">
                <img v-lazy="cgal3" alt="Lazy-loaded Image" class="oldimg" />
                <p class="oldp">本田项目汇总</p>
              </div>
            </figure>
            <!-- COIDEA:demo:grid:item END -->

            <!-- COIDEA:demo:grid:item START -->
            <figure
              class="coidea-item" @click="handleAnim(4)"

            >
              <div class="coidea-item-inner">
                <img v-lazy="cgal4" alt="Lazy-loaded Image" class="oldimg" />
                <p class="oldp">阿盖尔国际机场</p>
              </div>
            </figure>
            <!-- COIDEA:demo:grid:item END -->

            <!-- COIDEA:demo:grid:item START -->
            <figure
              class="coidea-item"
              @click="handleAnim(5)"
            >
              <div class="coidea-item-inner">
                <img v-lazy="cgal5" alt="Lazy-loaded Image" class="oldimg" />
                <p class="oldp">孟加拉GF项目</p>
              </div>
            </figure>
            <!-- COIDEA:demo:grid:item END -->

            <!-- COIDEA:demo:grid:item START -->
            <figure
              class="coidea-item"
              @click="handleAnim(6)"
            >
              <div class="coidea-item-inner">
                <img v-lazy="cgal6" alt="Lazy-loaded Image" class="oldimg" />
                <p class="oldp">森松VCR加拿大项目</p>
              </div>
            </figure>
            <!-- COIDEA:demo:grid:item END -->
          </div>
          <!-- COIDEA:demo:grid END -->

          <div class="modal" v-if="showModal == 1">
            <div class="modal-content">
              <div class="modal-content">
                <div class="textContent">
                  <h1 class="conH">上海惠群广场</h1>
                  <div class="container">
                    <div class="col-md-12">
                      <img v-lazy="cgal1" alt="" class="alImg">
                    </div>
                    <p>
                      <nav style="text-indent: 2em;">上海惠群广场，作为城市中的一个现代建筑典范，其设计与结构特点融合了创新与实用，旨在创造一个既符合现代审美又满足功能需求的空间。</nav>
                      <nav style="text-indent: 2em;">其外立面采用了双层玻璃幕墙，结合金属框架，形成现代而优雅的外观。玻璃幕墙之间嵌入了绿色植物墙，不仅美化了建筑外观，还提高了隔热性能，体现了环保理念。夜晚，建筑外立面通过精心设计的灯光系统，变成了光与影的艺术展示，成为城市的夜景亮点。</nav>
                      <nav style="text-indent: 2em;">结构上，本建筑采用了混合结构体系，结合了混凝土框架和钢结构，以提高抗震性和灵活性。其中，核心筒采用了高强度混凝土，外围则使用了轻质高强钢材，最大限度地减少了自重，同时保障了结构的安全稳定。</nav>
                      <nav style="text-indent: 2em;">建筑内部采用了多项绿色节能技术，如雨水收集系统用于景观灌溉，太阳能光伏板安装于屋顶，为部分公共区域供电，以及先进的楼宇自动化系统，实现能源的高效管理。</nav>
                    </p>
                    <div class="col-md-12 conList" style="border-top: 1px solid black ;border-bottom: 1px solid black ;">
                      <p>
                        <nav>
                          <strong>惠群广场一期</strong><br>
                          面积：1118㎡<br>
                          结构：主体钢结构<br>
                          系统：CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav>
                          <strong>惠群广场二期</strong><br>
                          面积：1120㎡<br>
                          结构：主体钢结构<br>
                          系统：LD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>惠群广场三期</strong><br>
                          面积：1246㎡<br>
                          结构：主体钢结构<br>
                          系统：CD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>惠群广场四期</strong><br>
                          面积：1266㎡<br>
                          结构：主体钢结构<br>
                          系统：CD屋面系统\CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >       
                          <strong>惠群广场五期</strong><br>
                          面积：1258㎡<br>
                          结构：主体钢结构<br>
                          系统：LD屋面系统\CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>惠群广场六期</strong><br>
                       
                          面积：1354㎡<br>
                          结构：主体钢结构<br>
                          系统：RD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >             
                          <strong>惠群广场七期</strong><br>
                          面积：1220㎡<br>
                          结构：主体钢结构<br>
                          系统：CD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>惠群广场八期</strong><br>
                          面积：1134㎡<br>
                          结构：主体钢结构<br>
                          系统：CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>地下室一层</strong><br>
                          面积：12981㎡<br>
                          结构：楼承板结构<br>
                          系统：LD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>地下室二层</strong><br>
                          面积：12981㎡<br>
                          结构：楼承板结构<br>
                          系统：LD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                      </p>
                    </div>
                    <div class="col-md-12 catalogp hidden-xs">
                      <div style="float: left;">
                        <a href="javascript:;" >上一条： 无</a>
                      </div>
                      
                      <div style="float: right;">
                        <a href="javascript:;" @click="nextAl" >下一条： 厦门银鹭集团</a>
                      </div>
                      <div class="goBack">
                        <a href="javascript:;" @click="closeShow">[返回]</a>
                      </div>
                    </div>
                    <div class="col-md-12 catalogp visible-xs">
                      <a href="javascript:;"><p>上一条： 无</p></a>
                      <a href="javascript:;" @click="nextAl"><p>下一条： 厦门银鹭集团</p></a>
                      <a href="javascript:;" @click="closeShow"><P>[返回]</P></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal" v-if="showModal == 2">
            <div class="modal-content">
              <div class="modal-content">
                <div class="textContent">
                  <h1 class="conH">厦门银鹭集团</h1>
                  <div class="container">
                    <div class="col-md-12">
                      <img v-lazy="cgal2" alt="" class="alImg">
                    </div>
                    <p>
                      <nav style="text-indent: 2em;">银鹭集团是厦门最大的民营食品企业,正有意向工业旅游业发展。因此,结构选材上,既要考虑到当地多台风多雨的气候特点,有要注重整体工程与周边环境的视觉效果。华胤公司生产的LD屋面系统,先进、安全,施工迅速,满足了银鹭集团的需求,故在整体工程中大面积采用了该屋面系统。</nav>
                      <nav style="text-indent: 2em;">具有国家三项专利技术的LD屋面系统，由特殊的压型钢板和专用的固定座连接而成。其独特的滑槽设计,令LD板单面板长几乎无限制,使得任何大跨度屋面,由屋脊至檐口采用单片无搭接钢板成为可能。加之高达62mm的波峰，LD屋面系统拥有完美的防漏、防风雪的能力，这是其他屋面系统都无法比拟的。LD板简洁的线条使建筑物充满现代感。</nav>
                      <nav style="text-indent: 2em;">陆续建设的160万平方米工程中,华胤公司不断优化设计,掌握产品质量,把握施工进度,完全控制预算,真正让客户享受到“一体化全面的工程服务体系”的优越性。</nav>
                    </p>
                    <div class="col-md-12 conList" style="border-top: 1px solid black ;border-bottom: 1px solid black ;">
                      <p>
                        <nav>
                          <strong>综合仓库</strong><br>
                          面积：12707㎡<br>
                          结构：钢屋盖结构<br>
                          系统：LD屋面系统<br>
                          工期：五个月<br><br>
                        </nav>
                        <nav>
                          <strong>罐头车间一期</strong><br>
                          面积：2160㎡<br>
                          结构：钢屋盖结构<br>
                          系统：CD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>饮料车间二期</strong><br>
                          面积：2376㎡<br>
                          结构：钢屋盖结构<br>
                          系统：CD屋面系统<br>
                          工期：两个月<br><br>
                        </nav>
                        <nav >
                          <strong>罐头车间二期</strong><br>
                          面积：5989㎡<br>
                          结构：全钢结构<br>
                          系统：CD屋面系统\CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >       
                          <strong>罐头车间三期</strong><br>
                          面积：6528㎡<br>
                          结构：全钢结构<br>
                          系统：LD屋面系统\CD墙面系统<br>
                          工期：五个月<br><br>
                        </nav>
                        <nav >
                          <strong>罐头车间七期</strong><br>                      
                          面积：2754㎡<br>
                          结构：全钢结构<br>
                          系统：LD屋面系统\RD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >             
                          <strong>罐头车间八期</strong><br>                   
                          面积：8820㎡<br>
                          结构：钢屋盖系统<br>
                          系统：LD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>罐头车间十期</strong><br>
                          面积：19404㎡<br>
                          结构：钢屋盖结构<br>
                          系统：LD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>八宝粥厂</strong><br>
                          面积：11853㎡<br>
                          结构：钢屋盖结构<br>
                          系统：LD屋面系统<br>
                          工期：五个月<br><br>
                        </nav>
                        <nav >       
                          <strong>锅炉房</strong><br>
                          面积：6291㎡<br>
                          结构：钢屋盖结构<br>
                          系统：CD屋面系统<br>
                          工期：一个月<br><br>
                        </nav>
                        <nav >
                          <strong>仓库扩建</strong><br>
                          面积：2046㎡<br>
                          结构：全钢结构<br>
                          系统：钢构系统<br>
                          工期：一个月<br><br>
                        </nav>
                        <nav >             
                          <strong>成品中心</strong><br>
                          面积：9712㎡<br>
                          结构：钢屋盖结构<br>
                          系统：CD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>污水处理厂</strong><br>
                          面积：6020㎡<br>
                          结构：全钢结构<br>
                          系统：LD屋面系统\RD墙面系统<br>
                          工期：五个月<br><br>
                        </nav>
                      </p>
                    </div>
                    <div class="col-md-12 catalogp hidden-xs">
                      <div style="float: left;">
                        <a href="javascript:;" @click="proAl">上一条： 上海惠群广场</a>
                      </div>
                      
                      <div style="float: right;">
                        <a href="javascript:;" @click="nextAl" >下一条： 本田项目汇总</a>
                      </div>
                      <div class="goBack">
                        <a href="javascript:;" @click="closeShow">[返回]</a>
                      </div>
                    </div>
                    <div class="col-md-12 catalogp visible-xs">
                      <a href="javascript:;" @click="proAl"><p>上一条： 上海惠群广场</p></a>
                      <a href="javascript:;" @click="nextAl"><p>下一条： 本田项目汇总</p></a>
                      <a href="javascript:;" @click="closeShow"><P>[返回]</P></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal" v-if="showModal == 3">
            <div class="modal-content">
              <div class="modal-content">
                <div class="textContent">
                  <h1 class="conH">本田项目汇总</h1>
                  <div class="container">
                    <div class="col-md-12">
                      <img v-lazy="cgal3" alt="" class="alImg">
                    </div>
                    <p>
                      <nav style="text-indent: 2em;">4S汽车展示厅是汽车销售、展览、维修与商业办公四大功能汇总一处的总称，它的诞生和林立式汽车业蓬勃发展的一个重要标志。各个品牌在自主设计上风格各有千秋，但主体结构却有规律可寻。一般楼高不会超过10米。正大门通向的都是汽车销售与展示的大厅堂，都以钢构结合玻璃幕墙挑高至屋顶，来增加内外观视的透明度，呈现亮堂又不失雅致的视觉环境。在这里，钢结构可以创造出符合这一要求的大跨度空间，使室内没有落柱，便于汽车的陈列停放，和人流的聚集。</nav>
                      <nav style="text-indent: 2em;">在大厅堂内多设有弧形的扶梯，通向中间的夹层办公室。这两部分约占整个建筑面积的1/3，其后的场地全部作为汽车修理之用。尽管是工厂，但它采用的钢结构墙面维护，多以干净、清爽、明快的，如梅花白之类的烤漆颜色示人，与前半部分建造风格结得很完整，避免产生头重脚轻的感觉。</nav>
                      <nav style="text-indent: 2em;">有的4S汽车展示厅位与市中心，在外观的设计上更追求过目不忘的效果。钢结构多样化的建造方式、现代感的气质，简洁硬朗的线条，赢得了汽车厂商们的青睐。上海大众4S汽车展厅，玻璃幕墙向外倾斜，配合圆形的钢构，从外部看犹如两把撑开的雨伞，结合局部的明黄色系，整个建筑看似钢构十分复杂，但仍然显得轻盈，绝无沉重之感。更多的汽车品牌4S汽车展示厅的设计采用规范的利落大方的方正造型。</nav>
                      <nav style="text-indent: 2em;">尽管，各个汽车名牌4S汽车展示厅建造上各有巧妙不同，但钢结构作为现代建筑的一种形式，在这一领域里的应用，其美观、营造空间大，较易于改建等优特点，较砖瓦结构而言，更为明显而卓越，更符合汽车的时尚感。其中最为突出的是工期短，从动工到商家正式营业最多只需60天的时间。如华胤钢工程公司承建的，湖北武汉东风雪铁龙4S展示厅，建筑面积为3000㎡，45天就完成了整个工程，由此钢结构的长处和华胤钢结构的长处和华胤工程公司的实力可见一斑。</nav>
                    </p>
                    <div class="col-md-12 conList" style="border-top: 1px solid black ;border-bottom: 1px solid black ;">
                      <p>
                        <nav>
                          <strong>泉州盛田汽车有限公司东风本田4S店</strong><br>
                          地点：福建泉州<br>
                          结构：全钢结构<br>
                          面积：3600㎡<br>
                          系统：SD屋面系统\RD墙面系统<br><br>
                        </nav>
                        <nav>
                          <strong>湖北东安工贸有限公司-东风雪铁龙4S展示厅</strong><br>
                          地点：湖北武汉<br>
                          面积：2376㎡<br>
                          结构：全钢结构<br>
                          系统：CD屋面系统\RD墙面系统<br><br>
                        </nav>
                        <nav >
                          <strong>青岛大山实业总公司汽车销售服务中心</strong><br>
                          地点：山东青岛<br>
                          面积：6870㎡<br>
                          结构：全钢结构<br>
                          系统：KD屋面系统\RD墙面系统<br><br>
                        </nav>
                        <nav >
                          <strong>厦门华盟装饰有限公司本田汽车销售店</strong><br>
                          地点：山东济南<br>
                          面积：3500㎡<br>
                          结构：全钢结构<br>
                          系统：CD屋面系统\LND双层系统\CD墙面系统<br><br>
                        </nav>
                        <nav >       
                          <strong>广州本田汽车（茂名）特约销售服务店</strong><br>
                          地点：广东茂名<br>
                          面积：2070㎡<br>
                          结构：全钢结构<br>
                          系统：CD屋面系统\RD墙面系统<br><br>
                        </nav>
                        <nav >
                          <strong>四扬汽车销售服务有限公司</strong><br>
                          捷达汽车销售店<br>
                          地点：贵州贵阳<br>
                          面积：2637㎡<br>
                          结构：全钢结构<br>
                          系统：KD屋面系统\LND双层系统\CD墙面系统<br><br>
                        </nav>
                        <nav >             
                          <strong>马自达汽车销售店</strong><br>
                          地点：贵州贵阳<br>
                          面积：2287㎡<br>
                          结构：全钢结构<br>
                          系统：KD屋面系统\CD墙面系统<br><br>
                        </nav>
                        <nav >
                          <strong>上海大众汽车安徽销售公司</strong><br>
                          地点：安徽合肥<br>
                          面积：3000㎡<br>
                          结构：全钢结构<br>
                          系统：KD屋面系统\LND双层系统\RD墙面系统<br><br>
                        </nav>
                      </p>
                    </div>
                    <div class="col-md-12 catalogp hidden-xs">
                      <div style="float: left;">
                        <a href="javascript:;" @click="proAl">上一条： 厦门银鹭集团</a>
                      </div>
                      
                      <div style="float: right;">
                        <a href="javascript:;" @click="nextAl" >下一条： 阿盖尔国际机场</a>
                      </div>
                      <div class="goBack">
                        <a href="javascript:;" @click="closeShow">[返回]</a>
                      </div>
                    </div>
                    <div class="col-md-12 catalogp visible-xs">
                      <a href="javascript:;" @click="proAl"><p>上一条： 厦门银鹭集团</p></a>
                      <a href="javascript:;" @click="nextAl"><p>下一条： 阿盖尔国际机场</p></a>
                      <a href="javascript:;" @click="closeShow"><P>[返回]</P></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal" v-if="showModal == 4">
            <div class="modal-content">
              <div class="modal-content">
                <div class="textContent">
                  <h1 class="conH">阿盖尔国际机场</h1>
                  <div class="container">
                    <div class="col-md-12">
                      <img v-lazy="cgal4" alt="" class="alImg">
                    </div>
                   <p>
                      <nav style="text-indent: 2em;">阿盖尔国际机场坐落在一片广袤的约275英亩的土地之上。这里的铺砌跑道十分壮观，其长度达到了2,743米（9,000英尺），宽度也有45米（150英尺），这样的规模设计是为了能够轻松容纳像波音747 - 400这种大型的喷气式飞机。</nav>
                      <nav style="text-indent: 2em;">航站楼处于前期设计阶段，建筑面积约为 13,470 平方米，每年可接待约 140 万名乘客。在整个融资过程中，我们能够迅速地把握机会、分析局势并且做出明智的决策。同时，这也离不开我们领导人的辛勤工作，他们积极奔走、精心规划、不懈努力，为机场建设的融资奠定了坚实的基础。而且，我们建立的持久的国际友谊也发挥了关键的作用，通过长期与各国建立友好关系，彼此之间相互信任、相互支持。正是这些特点结合在一起，使得我国能够从各个友好国家的赠款和承诺中受益，这些赠款和承诺就像及时雨一样，为阿盖尔国际机场的建设注入了强大的资金支持，让这个机场从蓝图逐渐走向现实。这些国家包括古巴共和国、委内瑞拉玻利瓦尔共和国、台湾、特立尼达和多巴哥、墨西哥、奥地利、马来西亚、土耳其和伊朗。</nav>
                    </p>
                    <div class="col-md-12 conList" style="border-top: 1px solid black ;border-bottom: 1px solid black ;">
                      <p>
                        <nav>
                          <strong>国际机场一期</strong><br>
                          面积：1410㎡<br>
                          结构：预制钢结构<br>
                          系统：LD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav>
                          <strong>国际机场二期</strong><br>
                          面积：1456㎡<br>
                          结构：预制钢结构<br>
                          系统：LD屋面系统/KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>国际机场三期</strong><br>
                          面积：1346㎡<br>
                          结构：预制钢结构<br>
                          系统：LD屋面系统/KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>国际机场四期</strong><br>
                          面积：1476㎡<br>
                          结构：预制钢结构<br>
                          系统：LD屋面系统/KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >       
                          <strong>国际机场五期</strong><br>
                          面积：1350㎡<br>
                          结构：预制钢结构<br>
                          系统：LD屋面系统/KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>国际机场六期</strong><br>
                          面积：1458㎡<br>
                          结构：预制钢结构<br>
                          系统：SD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >             
                          <strong>国际机场七期</strong><br>
                          面积：1432㎡<br>
                          结构：预制钢结构<br>
                          系统：SD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>国际机场八期</strong><br>
                          面积：1464㎡<br>
                          结构：预制钢结构<br>
                          系统：KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>国际机场九期</strong><br>
                          面积：1512㎡<br>
                          结构：预制钢结构<br>
                          系统：KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>国际机场十期</strong><br>
                          面积：566㎡<br>
                          结构：预制钢结构<br>
                          系统：KD屋面系统<br>
                          工期：一个月<br><br>
                        </nav>
                        
                      </p>
                    </div>
                    <div class="col-md-12 catalogp hidden-xs">
                      <div style="float: left;">
                        <a href="javascript:;" @click="proAl">上一条： 本田项目汇总</a>
                      </div>
                      
                      <div style="float: right;">
                        <a href="javascript:;" @click="nextAl" >下一条： 孟加拉GF项目</a>
                      </div>
                      <div class="goBack">
                        <a href="javascript:;" @click="closeShow">[返回]</a>
                      </div>
                    </div>
                    <div class="col-md-12 catalogp visible-xs">
                      <a href="javascript:;" @click="proAl"><p>上一条： 本田项目汇总</p></a>
                      <a href="javascript:;" @click="nextAl"><p>下一条： 孟加拉GF项目</p></a>
                      <a href="javascript:;" @click="closeShow"><P>[返回]</P></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal" v-if="showModal == 5">
            <div class="modal-content">
              <div class="modal-content">
                <div class="textContent">
                  <h1 class="conH">孟加拉GF项目</h1>
                  <div class="container">
                    <div class="col-md-12">
                      <img v-lazy="cgal5" alt="" class="alImg">
                    </div>
                   <p>
                      <nav style="text-indent: 2em;">孟加拉GF项目坐落于孟加拉国诺尔辛迪县。这个项目可是意义非凡，它由孟加拉政府直接进行投资建设，是保障孟加拉农业稳产增收的标志性项目。在孟加拉众多项目中，它是规模最大的化肥项目，并且还是孟加拉国首个绿色化肥厂。</nav>
                      <nav style="text-indent: 2em;">从产能方面来看，这个项目的设计产能十分可观。每年能够生产50万吨合成氨，80万吨尿素，并且还有8万吨二氧化碳能够被回收利用。而中国化学工程七公司孟加拉GF项目部在这个项目中承担着重要的角色，主要负责项目施工和部分采购工作。而华胤集团在其中对于项目的顺利推进有着至关重要的意义，从项目的基础建设施工到采购所需的部分材料等工作，都离不开华胤的精心组织与安排。</nav>
                    </p>
                    <div class="col-md-12 conList" style="border-top: 1px solid black ;border-bottom: 1px solid black ;">
                      <p>
                        <nav>
                          <strong>孟加拉GF一期</strong><br>
                          面积：1432㎡<br>
                          结构：全钢结构<br>
                          系统：LD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav>
                          <strong>孟加拉GF二期</strong><br>
                          面积：1552㎡<br>
                          结构：全钢结构<br>
                          系统：LD屋面系统/CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF三期</strong><br>
                          面积：1422㎡<br>
                          结构：全钢结构<br>
                          系统：LD屋面系统/CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF四期</strong><br>
                          面积：1398㎡<br>
                          结构：全钢结构<br>
                          系统：LD屋面系统/KRD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >       
                          <strong>孟加拉GF五期</strong><br>
                          面积：1378㎡<br>
                          结构：全钢结构<br>
                          系统：LD屋面系统/RD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF六期</strong><br>
                          面积：1466㎡<br>
                          结构：全钢结构<br>
                          系统：SD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >             
                          <strong>孟加拉GF七期</strong><br>
                          面积：1444㎡<br>
                          结构：全钢结构<br>
                          系统：SD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF八期</strong><br>
                          面积：1412㎡<br>
                          结构：全钢结构<br>
                          系统：LND双层系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF九期</strong><br>
                          面积：1512㎡<br>
                          结构：全钢结构<br>
                          系统：LND双层系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF十期</strong><br>
                          面积：1478㎡<br>
                          结构：全钢结构<br>
                          系统：LND双层系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF十一期</strong><br>
                          面积：1362㎡<br>
                          结构：全钢结构<br>
                          系统：KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF十二期</strong><br>
                          面积：1452㎡<br>
                          结构：全钢结构<br>
                          系统：KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF十三期</strong><br>
                          面积：1434㎡<br>
                          结构：全钢结构<br>
                          系统：KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF十四期</strong><br>
                          面积：1452㎡<br>
                          结构：全钢结构<br>
                          系统：KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>孟加拉GF十五期</strong><br>
                          面积：1068㎡<br>
                          结构：全钢结构<br>
                          系统：KD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                      </p>
                    </div>
                    <div class="col-md-12 catalogp hidden-xs">
                      <div style="float: left;">
                        <a href="javascript:;" @click="proAl">上一条：  阿盖尔国际机场</a>
                      </div>
                      
                      <div style="float: right;">
                        <a href="javascript:;" @click="nextAl" >下一条： 	森松VCR加拿大项目</a>
                      </div>
                      <div class="goBack">
                        <a href="javascript:;" @click="closeShow">[返回]</a>
                      </div>
                    </div>
                    <div class="col-md-12 catalogp visible-xs">
                      <a href="javascript:;" @click="proAl"><p>上一条：  阿盖尔国际机场</p></a>
                      <a href="javascript:;" @click="nextAl"><p>下一条： 	森松VCR加拿大项目</p></a>
                      <a href="javascript:;" @click="closeShow"><P>[返回]</P></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal" v-if="showModal == 6">
            <div class="modal-content">
              <div class="modal-content">
                <div class="textContent">
                  <h1 class="conH">森松VCR加拿大项目</h1>
                  <div class="container">
                    <div class="col-md-12">
                      <img v-lazy="cgal6" alt="" class="alImg">
                    </div>
                   <p>
                      <nav style="text-indent: 2em;">森松VCR加拿大项目是一个创新的环保项目，位于加拿大魁北克省，由我们的钢结构公司与加拿大碳回收公司合作开发。该项目旨在利用先进的电解水制氢技术，将不可回收的废物和残余生物质转化为生物燃料和循环化学品，助力实现可持续发展目标。</nav>
                      <nav style="text-indent: 2em;">该项目将建设北美最大的90兆瓦质子交换膜（PEM）电解槽系统，预计于2025年投入运营。通过这一系统，工厂将能够生产可再生氢气和氧气，进一步支持低碳燃料和化学品的生产。项目每年预计将减少超过17万吨的温室气体排放，为应对气候变化贡献力量。我们的钢结构公司在项目中提供高效、环保的钢结构体系，确保工厂的安全性和耐用性。通过这一合作，我们不仅展示了公司在环保领域的承诺，也积极推动绿色经济的发展，助力加拿大实现2050年净零排放的目标。</nav>
                      <nav style="text-indent: 2em;">森松VCR加拿大项目是一个典范，体现了如何通过技术创新和资源循环利用，推动工业的可持续发展，同时为环境保护做出积极贡献。</nav>
                    </p>
                    <div class="col-md-12 conList" style="border-top: 1px solid black ;border-bottom: 1px solid black ;">
                      <p>
                        <nav>
                          <strong>加拿大VCR一期</strong><br>
                          面积：1276㎡<br>
                          结构：全钢结构<br>
                          系统：SD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav>
                          <strong>加拿大VCR二期</strong><br>
                          面积：1312㎡<br>
                          结构：全钢结构<br>
                          系统：SD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>加拿大VCR三期</strong><br>
                          面积：1278㎡<br>
                          结构：全钢结构<br>
                          系统：SD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>加拿大VCR四期</strong><br>
                          面积：1266㎡<br>
                          结构：全钢结构<br>
                          系统：SD屋面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >       
                          <strong>加拿大VCR五期</strong><br>
                          面积：1288㎡<br>
                          结构：全钢结构<br>
                          系统：SD屋面系统\LND双层系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>加拿大VCR六期</strong><br>
                          面积：1366㎡<br>
                          结构：全钢结构<br>
                          系统：SD屋面系统\LND双层系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >             
                          <strong>加拿大VCR七期</strong><br>
                          面积：1414㎡<br>
                          结构：全钢结构<br>
                          系统：SD屋面系统\LND双层系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>加拿大VCR八期</strong><br>
                          面积：1412㎡<br>
                          结构：全钢结构<br>
                          系统：SD屋面系统\LND双层系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>加拿大VCR九期</strong><br>
                          面积：1412㎡<br>
                          结构：全钢结构<br>
                          系统：LND双层系统\CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>加拿大VCR十期</strong><br>
                          面积：1378㎡<br>
                          结构：全钢结构<br>
                          系统：LND双层系统\CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>加拿大VCR十一期</strong><br>
                          面积：1364㎡<br>
                          结构：全钢结构<br>
                          系统：CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                        <nav >
                          <strong>加拿大VCR十二期</strong><br>
                          面积：1152㎡<br>
                          结构：全钢结构<br>
                          系统：CD墙面系统<br>
                          工期：三个月<br><br>
                        </nav>
                      </p>
                    </div>
                    <div class="col-md-12 catalogp hidden-xs">
                      <div style="float: left;">
                        <a href="javascript:;" @click="proAl">上一条：  孟加拉GF项目</a>
                      </div>
                      <div style="float: right;">
                        <a href="javascript:;">下一条： 无</a>
                      </div>
                      <div class="goBack">
                        <a href="javascript:;" @click="closeShow">[返回]</a>
                      </div>
                    </div>
                    <div class="col-md-12 catalogp visible-xs">
                      <a href="javascript:;" @click="proAl"><p>上一条： 孟加拉GF项目</p></a>
                      <a href="javascript:;"><p>下一条： 无</p></a>
                      <a href="javascript:;" @click="closeShow"><P>[返回]</P></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
import { TimelineMax } from 'gsap'
var imagesLoaded = require('imagesloaded')
export default {
  data() {
    return {
      cgal1:require('@/components/img/cgal/al1.jpg'),
      cgal2:require('@/components/img/cgal/al2.jpg'),
      cgal3:require('@/components/img/cgal/al3.jpg'),
      cgal4:require('@/components/img/cgal/al4.jpg'),
      cgal5:require('@/components/img/cgal/al5.jpg'),
      cgal6:require('@/components/img/cgal/al6.jpg'),
      // 搜索框
      svalue: '',
      // 下拉框
      sitem: '',
      // 列表数
      listNum: 1,
      // 当前页
      nowNum: 1,
      // 每页显示
      perPage: 12,

      // 当前数据
      nowdata: [],
      // 显示数据
      showdata: [],
      // 页面显示
      showModal: 0,
    }
  },
  methods: {
    // 调用全局方法，滚动指定id
    forId(tId) {
      console.log(tId);
      this.$store.dispatch('toID', tId);
    },
    // 随机淡出
    handleAnim(num) {
      var tl = new TimelineMax()
      for (let i = 0; i < 6; i++) {
        tl.to(
          this.$refs.grid.children[i],
          0.6,
          {
            force3D: true,
            x: Math.random() > 0.5 ? -125 : 250,
            y: Math.random() > 0.5 ? -125 : 250,
            scale: -(Math.random() > 0.5 ? -0.25 : -0.5),
            autoAlpha: 0,
          },
          Math.random()
        )
      }
      setTimeout(() => {
        console.log('这是延时装置')
        this.showModal = num
        tl.reverse()
      }, 1800)
    },
    proAl() {
      this.showModal--
    },
    nextAl() {
      this.showModal++
    },
    // 关闭内容
    closeShow() {
      this.showModal = 0
    },
    // 获取列表长度
    listLen() {
      this.listNum = parseInt(this.nowdata.length / this.perPage) + 1
    },
    // 获取当前页
    showpage(nowNum) {
      this.nowNum = nowNum
      const start = (nowNum - 1) * this.perPage
      this.showdata = this.nowdata.slice(start, start + this.perPage)
    },
    pPage(nowNum) {
      if (nowNum != 1) {
        this.nowNum -= 1
        this.showpage(this.nowNum)
      }
    },
    nPage(nowNum) {
      console.log('**************下一页*****************')
      console.log(nowNum)
      console.log(this.listNum)
      if (nowNum != this.listNum) {
        console.log('进入')
        this.nowNum += 1
        console.log(this.nowNum)
        this.showpage(this.nowNum)
      }
    },
    // 获取全部数据
    async getCgalData() {
      this.nowdata = []
      this.svalue = ''
      await this.$store.dispatch('CgalList')
      this.nowdata = this.$store.state.cgal.cgalList
      this.listLen()
      this.showpage(1)
    },
    // 获取分类数据
    async getSelectData() {
      this.nowdata = []
      this.sitem = this.$refs.selectItem.value
      if (this.sitem == '全部') {
        this.getCgalData()
      } else {
        await this.$store.dispatch('CgalCentList', this.$refs.selectItem.value)
        this.nowdata = this.$store.state.cgal.cgalCentList
        this.listLen()
        this.showpage(1)
      }
    },
    // 获取搜索数据
    async getCgalSearchData() {
      this.nowdata = []
      await this.$store.dispatch('CgalSearchList', this.svalue)
      this.nowdata = this.$store.state.cgal.cgalSearchList
      this.listLen()
      this.showpage(1)
    },
  },
  computed: {
    ...mapGetters({
      cgalList: (state) => state.cgal.cgalList,
      cgalCentList: (state) => state.cgal.cgalCentList,
      cgalSearchList: (state) => state.cgal.cgalSearchList,
    }),
  },
  mounted() {
    // 了解详情路由跳转
    if(this.$route.query.num){
      this.showModal=this.$route.query.num
  }else{
    this.showModal=0
  }
    // 获取成功案例
    this.getCgalData()
    // 典型案例
    imagesLoaded.makeJQueryPlugin($)
    var grid = $('.coidea-grid-holder').find('.coidea-grid'),
      tl = new TimelineMax({
        paused: true,
      }),
      tlInner = new TimelineMax({
        paused: true,
      }),
      numItems = grid.find('.coidea-item').length

    // main timeline
    for (var i = 0; i < numItems; i++) {
      tl.to(
        grid.find('.coidea-item')[i],
        0.6,
        {
          force3D: true,
          x: Math.random() > 0.5 ? -125 : 250,
          y: Math.random() > 0.5 ? -125 : 250,
          scale: -(Math.random() > 0.5 ? -0.25 : -0.5),
          autoAlpha: 0,
        },
        Math.random()
      )
    }

    // hover
    $('.coidea-grid .coidea-item').hover(
      function () {
        $('.coidea-item').removeClass('coidea-hovered')
        $(this).addClass('coidea-hovered')
      },
      function () {
        $(this).removeClass('coidea-hovered')
      }
    )

    // close
    $('.coidea-activated-item').on('click', '.coidea-close', function () {
      console.log('close')
      // reverse timelines
      tlInner.reverse()
      tl.reverse()
    })

    // set background-images for each item
    $(function () {
      $('.coidea-item').each(function () {
        // get data image
        var imageUrl = $(this).find('img').attr('src')
        // set background
        $('.coidea-activated-item').find('.coimg').attr('src', imageUrl)
      })
    })

    $('.coidea-grid-holder').imagesLoaded({ background: true }, function () {
      $('body').removeClass('loading')
    })
  },
}
</script>

<style scoped>
/* 返回按钮 */
.goBack{
  margin: 0 auto;
  width: 46px
}
a{
  text-decoration:none;
}
/* 滚动 */
#alfx{
  margin-top: 43px;
  /* padding-top: 40px; */
}
/* 边框 */
.conBorder{
  border-bottom: 1px solid black;
}
@media (min-width: 1200px) {
  .container{
    padding: 0 180px;
    width: 100%;
  }
}
/* alfx */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
}

.modal-content {
  font-size: 17px;
  line-height: 32px;
  text-align: left;
  padding: 8px;
  margin: auto;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-image: url(@/components/img/cgal/conbg.jpg);
}
.modal-content::-webkit-scrollbar {
  display: none;
}
.conH {
  text-align: center;
  font-family: '微软雅黑'; /*设置字体*/
  font-size: 64px; /*设置字体大小*/
  font-weight: bolder; /*设置字体粗细*/
  -webkit-text-stroke: 1px #000; /*文字描边*/
  -webkit-text-fill-color: transparent; /*设置文字的填充颜色*/
  text-shadow: 2px 2px 2px grey;
  border-bottom: 3px solid black;
  padding-bottom: 35px;
}

.textContent {
  padding: 10px;
  border: 1px solid black;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}
.catalogp {
  padding: 10px 15px;
  border-top: 1px solid#ed9048;
  border-bottom: 1px solid #ed9048;
}
.conList {
  padding: 15px 0;
  column-count: 3;
  column-gap: 12px;
  max-height: 800px;
  overflow: auto;
}
@media (max-width: 768px) {
  .conH {
    font-size: 35px;
  }
  .cgcon {
    font-size: 12px !important;
  }
  .conList {
    column-count: 1;
    max-height: 100%;
  }
  .cgcon .coidea-grid-holder .coidea-headline{
    margin: 50px auto 0 !important;
  }
  .modal-content{
    font-size: 12px !important;
    line-height: 24px !important;
  }
  .lbImg{
    height: 20vh !important;
    padding: 2px !important;
  }
}
/* 典型案例 */
.dxalift {
  padding-left: 39px;
}
.alTitle {
  font-size: 20px;
  color: red;
}
.altop {
  margin: 10px 0;
  padding: 10px 0;
  border-bottom: 1px solid #000;
}

label {
  font-family: sans-serif;
  font-size: 1rem;
  padding-right: 10px;
}

select {
  font-size: 1.5rem;
  padding: 2px 5px;
}
.lbtop {
  margin-top: 90px;
}
.lbTop {
  margin: 7px;
}
.lbButton {
  text-align: center;
  padding: 10px 1.5vw;
}
.lbImg {
  max-width: 100%;
  width: 100%;
  padding: 15px;
  height: 25vh;
}
.lbhi {
  font-size: 15px;
  text-align: center;
}
@media screen and (max-width: 768px) {
  .dxalift {
    padding: 0 30px;
  }
  .lbtop {
    margin-top: 10px;
  }
  .foSize {
    font-size: 13px;
    text-align: right;
  }
  .lbhi {
    font-size: 10px !important;
  }
  .lbImg {
    padding: 0;
  }
  .ssal {
    border: 1px solid black;
    padding: 15px;
    margin: 10px -20px;
  }
}
/* 头部 */
.page-heading {
  background-image: url(@/components/img/cgal/top11.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  text-align: center;
}

.page-heading .heading-content h1 {
  font-size: 32px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  background-color: rgba(5,5,5,0.9);
  display: inline-block;
  margin-bottom: 0;
  margin-top: 220px;
  padding: 20px 60px;
}

.page-heading .heading-content em {
  font-style: normal;
  font-weight: 200;
}
/* 导航栏 */
.zznav {
  position: relative;
  width: 100%;
  height: 65px;
  background-color: #262626;
}
.zzitem {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  display: flex; /*弹性布局，使li排成一行*/
  z-index: 1;
}
.zzitem li {
  list-style: none;
}
.zzitem li a {
  position: relative;
  display: block;
  padding: 10px 20px;
  margin: 0 40px;
  text-decoration: none;
  text-transform: uppercase; /*将字符转为大写*/
  color: #8f8c8c;
  font-weight: bold;
  font-size: 22px;
  cursor: pointer;
  /* transition: 0.5s; */
}
.zzitem li a:hover {
  color: #fff;
}
.zzitem li a:before {
  /*a:before，在a链接之前添加新内容，这里添加上下边框*/
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top: 2px solid #a56c41;
  border-bottom: 2px solid #a56c41;
  transform: scaleY(2); /*拉长边框两倍*/
  opacity: 0; /*边距不显示*/
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:before {
  transform: scaleY(1); /*拉长边框两倍*/
  opacity: 1;
}
.zzitem li a:after {
  content: '';
  position: absolute;
  top: 1px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #a56c41;
  transform: scale(0);
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:after {
  transform: scale(1);
}
/* 小滚轮 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  display: block;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #a56c41;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 12px;
  text-align: center;
  background: #a56c41;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #ed9048;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: -75px;
  left: -25px;
}

#ss_menu div:nth-child(2) {
  top: -25px;
  left: -75px;
}

/* 典型案例 */
.oldp {
  text-align: center;
  background-color: #fff;
  color: #000;
}
.oldimg {
  width: 31vw;
  height: 24vw;
}
.coimg {
  width: 100vw;
  height: 100vh;
}
/* 案例列表 */
.cgcon {
  font-family: 等线Light;
  color: black;
  background: #fff;
  font-size: 16px;
  line-height: 24px;
}
.cgcon.loading {
  display: none !important;
}
.cgcon .coidea-grid-holder {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;
}
.cgcon .coidea-grid-holder .coidea-headline {
  position: relative;
  display: block;
  width: 100%;
  max-width: 640px;
  height: auto;
  overflow: hidden;
  margin: 83px auto 0;
  text-align: center;
}
.cgcon .coidea-grid-holder .coidea-headline h1 {
  font-family: 等线Light;
  font-size: 48px;
  line-height: 56px;
  color: #000;
  margin: 0;
  padding: 0;
}
.cgcon .coidea-grid-holder .coidea-headline p {
  position: relative;
  display: block;
  width: 100%;
  max-width: 480px;
  height: auto;
  margin: 0 auto;
  padding-top: 64px;
}
.cgcon .coidea-grid-holder .coidea-headline p:before {
  background-color: #000;
  content: '';
  position: absolute;
  display: block;
  width: 64px;
  height: 2px;
  top: 32px;
  left: 50%;
  margin-left: -32px;
}
.cgcon .coidea-grid-holder .coidea-grid {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;
  margin: 48px auto;
  font-size: 24px;
  line-height: 36px;
  color: #dedede;
}
/* coidea:coidea-item */
.cgcon .coidea-grid-holder .coidea-grid figure.coidea-item {
  font-weight: 700;
  position: relative;
  display: block;
  width: 38%;
  width: 31vw;
  height: 360px;
  height: 26vw;
  float: left;
  padding: 0;
  margin: 1%;
  opacity: 1;
  visibility: visible;
  z-index: 2;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  /* font-smoothing: antialiased; */
  will-change: transform;
  cursor: pointer;
}
.cgcon .coidea-grid-holder .coidea-grid figure.coidea-item:before {
  content: '';
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 8%;
  top: 1vw;
  right: -4%;
  right: -1vw;
  z-index: -1;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.cgcon .coidea-grid-holder .coidea-grid figure.coidea-item:hover:before {
  top: 0;
  right: 0;
}
.cgcon .coidea-grid-holder .coidea-grid figure.coidea-item .coidea-item-inner {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-size: cover;
  background-position: center center;
  box-shadow: 0 7px 15px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.12);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  transition-delay: 0.3s;
}
.cgcon
  .coidea-grid-holder
  .coidea-grid
  figure.coidea-item:hover
  .coidea-item-inner {
  opacity: 0.75;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.15), 0 15px 12px rgba(0, 0, 0, 0.11);
}
/* coidea:activated-item */
.cgcon .coidea-grid-holder .coidea-activated-item {
  background-color: #131922;
  color: #ffffff;
  position: fixed;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  visibility: hidden;
  z-index: 1;
  transform: scale(0.8);
  transition: all 0.4s ease-in-out;
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-content {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease-in-out;
  margin-top: 50vh;
  margin-left: 50vw;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 100;
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-content h4 {
  font-family: 'Cardo', serif;
  font-size: 36px;
  line-height: 44px;
  margin: 0;
  padding: 0;
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-content p {
  position: relative;
  display: block;
  width: 100%;
  max-width: 768px;
  height: auto;
  margin: 0 auto;
  padding: 16px 0;
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-content a {
  color: #000;
  font-weight: 700;
  text-decoration: none;
  text-transform: uppercase;
  outline: 0px none;
  outline: 0px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-content a:hover {
  color: rgba(215, 38, 56, 1);
}
.cgcon .coidea-grid-holder .coidea-activated-item.active {
  opacity: 1;
  visibility: visible;
  z-index: 3;
  transform: scale(1);
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-content.active {
  opacity: 1;
  visibility: visible;
}
/* coidea:activated-item:close */
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-close {
  display: block;
  position: absolute;
  display: block !important;
  opacity: 0;
  visibility: hidden;
  width: 32px;
  height: 32px;
  top: 32px;
  right: 32px;
  z-index: 120;
  cursor: pointer;
  margin-top: 80px;
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-close span {
  display: block;
  position: relative;
  background-color: transparent !important;
  color: #ffffff;
  height: 32px;
  font-size: 48px;
  line-height: 48px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-close span img {
  display: block;
  position: relative;
  width: 32px;
  height: 32px;
  cursor: pointer;
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-close span i {
  display: block;
  position: absolute;
  color: #ffffff;
  width: 14px;
  height: 42px;
  font-size: 30px;
  line-height: 30px;
  margin: 0;
  top: -2px;
  left: 0;
  opacity: 1;
  visibility: visible;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-close span:hover {
  color: #2980b9;
}
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-close span:hover i {
  color: #2980b9;
}
/* coidea:activated-item:background */
.cgcon .coidea-grid-holder .coidea-activated-item .coidea-background {
  content: '';
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin-top: 80px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  z-index: 2;
  background-size: cover;
  background-position: center center;
  opacity: 0;
  visibility: hidden;
}
.alImg{
  padding: 5px 20px;
  width: 100%;
  max-width:100%;
  height: 60vh;
}
@media screen and (max-width: 768px) {
  .cgcon .coidea-grid-holder .coidea-grid figure.coidea-item {
    width: 47vw;
    height: 34vw;
  }
  .oldimg {
    width: 47vw;
    height: 29vw;
  }
  .oldp {
    font-size: 12px;
  }
  .cgcon .coidea-grid-holder .coidea-grid {
    line-height: 18px;
  }
  .cgcon .coidea-grid-holder .coidea-activated-item .coidea-content h4 {
    font-size: 30px;
    line-height: 35px;
  }
  .cgcon .coidea-grid-holder .coidea-activated-item .coidea-content p {
    font-size: 10px;
    line-height: 18px;
  }
  .cgcon .coidea-grid-holder .coidea-activated-item .coidea-content {
    margin-top: 53vh;
  }
  .cgcon .coidea-grid-holder .coidea-activated-item .coidea-close {
    width: 20px;
    height: 20px;
    top: 20px;
    right: 20px;
  }
  .cgcon .coidea-grid-holder .coidea-activated-item .coidea-close span img {
    width: 20px;
    height: 20px;
  }
  .cgcon .coidea-grid-holder .coidea-headline h1 {
    font-size: 34px;
    line-height: 43px;
  }
  .alImg{
  padding: 2px;
  width: 100%;
  max-width:100%;
  height: 25vh;
}
}
@media screen and (min-width: 2000px){
  .page-heading .heading-content h1{
    font-size: 40px;
  }
  .zzitem li a{
    margin: 0 50px;
    font-size: 25px;
  }
  .page-heading .heading-content h1{
    font-size: 40px;
  }
  .zzitem li a{
    margin: 0 50px;
    font-size: 25px;
  }
  .alTitle{
    font-size: 30px;
  }
  .form-horizontal .control-label{
    font-size: 16px;
  }
  .form-control{
    height: 46px;
  }
  .cgcon .coidea-grid-holder .coidea-grid{
    font-size: 25px;
    line-height: 55px;
  }
  .conH{
    font-size: 70px;
  }
  .modal-content{
    font-size: 20px;
    line-height: 40px;
  }
  .goBack{
    width: 80px;
  }
  .conList{
    max-height: 1000px;
  }
}

</style>
